export const consents = [
  {
    title: 'appointments.consent.createAccount',
    value: 'createAccount',
    required: true,
  },
]

export const optIns = [
  {
    title: 'appointments.optIn.marketingEmails',
    value: 'subscribe-newsletter',
  },
  {
    title: 'appointments.optIn.directMail',
    value: 'direct-mail',
  },
  {
    title: 'appointments.optIn.marketingSMS',
    value: 'marketing-sms',
  },
]
